jQuery(document).ready(function() {
  // Hide all steps except the first one
  jQuery('.s-v2--step-item:not(:first)').hide();

  // Function to fetch product data via AJAX
  function getProductData(productHandle) {
    var apiUrl = '/products/' + productHandle + '.js';
    $.ajax({
      url: apiUrl,
      dataType: 'json',
      success: function(data) {
        // Process the product data and hide non-selected options
        processProductData(data);
      },
      error: function() {
        console.error('Error fetching product data.');
      }
    });
  }

  // Function to process the product data and hide non-selected options
  function processProductData(productData) {
    var productOptions = productData.options;
    
    // Loop through each option in the product data
    var optionSelector = $('[step-option="Grind"] .step-box--item');
    $(optionSelector).hide();
    productOptions.forEach(function(option) {
      var optionValues = option.values;
      var optionName = option.name;
      
      // Loop through each option value
      optionValues.forEach(function(value) {
        if(optionName == 'Grind'){
          $('[step-option="Grind"] .step-box--item[data-option-value="'+ value +'"]').show();
        }
      });
    });
  }
  
  // Next button click event
  jQuery(document).on('click','.step-next-btn',function(){
    var currentStepOption = $(this).closest('.step-box--list').attr('step-option');
    var currentStep = jQuery(this).closest('.s-v2--step-item');
    var nextStep = currentStep.next('.s-v2--step-item');
    var nextoptionStep = $(this).attr('data-option');
    var currentProduct = $(this).data('product');
    var currentOption = $(this).data('option-value');
    
    if(currentProduct){
      $('.s-v2--step2 .step-box--list').addClass('hide');
      $('.s-v2--step2 .step-box--list[data-product-type="'+ currentProduct +'"]').removeClass('hide');
      $('.final-product-data').addClass('hide').removeClass('active');
      $('.final-product-data[data-product-handle="'+ currentProduct +'"]').removeClass('hide').addClass('active');
      getProductData(currentProduct);

      if(currentProduct == 'new-pods' || currentProduct == 'new-pods-prepaid-gift'){
        $('.step-box--list[step-option="frequency"] .step-box--item').attr('data-option','pods-amount');
      }else{
        $('.step-box--list[step-option="frequency"] .step-box--item').attr('data-option','Grind');
      }
      
      if(currentProduct == 'new-monthly-subscription-filter' || currentProduct == 'new-monthly-subscription-filter-prepaid-gift' || currentProduct == 'new-pods' || currentProduct == 'new-pods-prepaid-gift'){
        $('[data-option-value="2kg - 120 cups"]').hide();
        $('[data-option-value="4kg - 240 cups"]').hide();
      }else{
        $('[data-option-value="2kg - 120 cups"]').show();
        $('[data-option-value="4kg - 240 cups"]').show();
      }
    }
    
    if(currentOption){
      var variantWrapper = $('.final-product-data.active').find('.variant-selection');
      variantWrapper.find('input[type="radio"][value="' + currentOption + '"]').trigger('click');

      if(currentOption == 'Bear House Roast (Pods)'){
        $('[data-option-value="10 Pods"]').hide();
        $('[data-option-value="40 Pods"]').show();
        $('[data-option-value="100 Pods"]').show();
      }else if(currentOption == 'Los Altos Decaf (Pods)'){
        $('[data-option-value="40 Pods"]').hide();
        $('[data-option-value="100 Pods"]').hide();
        $('[data-option-value="10 Pods"]').show();
      }
    }

    if($(this).closest('.step-box--list').attr('step-option') == 'frequency'){
      var frequencyVal = $(this).attr('data-option-value');
      var frequencyTime = $(this).attr('data-option-time');
      var foundFrequencyVal = $('.final-product-data.active').find('.rc_widget__option__plans__dropdown option[data-plan-option="'+ frequencyVal +'"]').val();
      $('.final-product-data.active').find('.rc_widget__option__plans__dropdown').val(foundFrequencyVal).change();
      $('.final-product-data.active').find('.frequency-data').text('Every '+ frequencyTime +' Months');
      $('.final-product-data.active').find('.frequency-data').removeClass('hide');
    }

    if(currentStepOption == 'Bean Type'){
      $(this).closest('.step-box--list').find('.step-next-btn').removeClass('active');
      $(this).addClass('active');
    }

    if(currentStepOption == 'Grind'){
      var firstVariant = $('.step-next-btn.active').attr('data-option-value');
      if(firstVariant == 'Sugar Cane Decaf - La Serranía (Filter)' && currentOption == 'Wholebean'){
        $('[data-option-value="500g - 30 cups"]').hide();
      }else if(firstVariant == 'Bear House Blend' || firstVariant == 'Bear House Roast' || firstVariant == 'Sugar Cane Decaf - La Serranía'){  
        if(currentOption != 'Wholebean'){
          $('[data-option-value="2kg - 120 cups"]').hide();
          $('[data-option-value="4kg - 240 cups"]').hide();
        }else{
          $('[data-option-value="2kg - 120 cups"]').show();
          $('[data-option-value="4kg - 240 cups"]').show(); 
        }
      }else{
        $('[data-option-value="500g - 30 cups"]').show();
      }
    }
    
    // Hide current step and show next step
    currentStep.hide();
    if(nextoptionStep){
      $('.step-box--list[step-option="'+ nextoptionStep +'"]').closest('.s-v2--step-item').show();
      var subOption = $('.step-box--list[step-option="'+ nextoptionStep +'"]').closest('.s-v2--step-inner').attr('step-option');
      if(subOption){
        $('.step-box--list[step-option="'+ nextoptionStep +'"]').closest('.s-v2--step-item').find('.s-v2--step-inner').addClass('hide');
        $('.step-box--list[step-option="'+ nextoptionStep +'"]').closest('.s-v2--step-inner').removeClass('hide');
      }
      if(nextoptionStep == 'result'){
        var stepBack = $(this).closest('.step-box--list').attr('step-option');
        $('.result-step-back').attr('step-back',stepBack);
      }else{
        $('.result-step-back').removeAttr('step-back');        
      }
      var pods_top = $('.step-box--list[step-option="'+ nextoptionStep +'"]').closest('.s-v2--step-item');
      $('html, body').animate({
        scrollTop: pods_top.offset().top - 100
      }, 500);
    }else{
      nextStep.show();
      $('html, body').animate({
        scrollTop: nextStep.offset().top - 100
      }, 500);
    }

    $('.product-gallery__main').flickity('resize');

  });

  // Back button click event
  jQuery(document).on('click','.step-back-btn',function(){
    var currentStep = jQuery(this).closest('.s-v2--step-item');
    var previousStep = currentStep.prev('.s-v2--step-item');
    var backStepCheck = $(this).attr('step-back');

    // Hide current step and show previous step
    currentStep.hide();
    if(backStepCheck){
      $('.step-box--list[step-option="'+ backStepCheck +'"]').closest('.s-v2--step-item').show();
      var pods_back = $('.step-box--list[step-option="'+ backStepCheck +'"]').closest('.s-v2--step-item');
      $('html, body').animate({
        scrollTop: pods_back.offset().top - 100
      }, 500);
    }else{
      previousStep.show();
      $('html, body').animate({
          scrollTop: previousStep.offset().top - 100
      }, 500);
    }
  });

  /* Same Height Blog Grid */
  /*function blog_section() {  
  jQuery(".step-box--list .step-box--item").each(function () {
    function e() {
      jQuery(".step-box--list .step-box--item").css("height", "auto");
      var e = -1;
      jQuery(".step-box--list .step-box--item").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".step-box--list .step-box--item").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });
  }
  blog_section();
  jQuery(window).on('load resize orientationchange', blog_section); 
  */
});